import * as moment from "moment";
import { BIG_LOGO } from "./contantsTemplate";
moment.locale('es')

export const pdfReporteIngresosTemplate = async (revenueSummary: any): Promise<any> => {
  // Encabezados de las tablas de detalle
  const storageHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Días estadía', style: 'headerTableData' },
    { text: 'Fecha salida', style: 'headerTableData' },
    { text: 'Descuento', style: 'headerTableData' },
    { text: 'Valor', style: 'headerTableData' }
  ];

  const transshipmentHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Fecha proceso', style: 'headerTableData' },
    { text: 'Descuento', style: 'headerTableData' },
    { text: 'Valor', style: 'headerTableData' }
  ];

  // Filas de detalle de almacenamiento
  const storageRows = revenueSummary.transactions.storage.map(item => [
    { text: item.container },
    { text: item.containerType },
    { text: item.driverName },
    { text: item.stayDays ?? '' },
    { text: item.checkOutDate ? moment(item.checkOutDate).format('YYYY-MM-DD HH:mm') : '' },
    { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
    { text: item.amount ? `$${Number(item.amount).toLocaleString('es-CO')}` : '' }
  ]);

  // Filas de detalle de transbordo
  const transshipmentRows = revenueSummary.transactions.transshipment.map(item => [
    { text: item.container },
    { text: item.containerType },
    { text: item.driverName },
    { text: item.processedAt ? moment(item.processedAt).format('YYYY-MM-DD HH:mm') : '' },
    { text: item.discount ? `$${Number(item.discount).toLocaleString('es-CO')}` : '' },
    { text: item.amount ? `$${Number(item.amount).toLocaleString('es-CO')}` : '' }
  ]);

  // Resumen por tipo de contenedor
  const byContainerTypeRows = [
    [
      { text: 'Tipo', style: 'headerTableData' },
      { text: 'Almacenados', style: 'headerTableData' },
      { text: 'Transbordos', style: 'headerTableData' },
      { text: 'Total movimientos', style: 'headerTableData' },
      { text: 'Ingresos', style: 'headerTableData' }
    ],
    ...revenueSummary.byContainerType.map(type => [
      { text: type.typeName },
      { text: type.storage.transactionCount },
      { text: type.transshipment.transactionCount },
      { text: type.totals.transactionCount },
      { text: `$${Number(type.totals.totalRevenue).toLocaleString('es-CO')}` }
    ])
  ];


    // Resumen general
  const summaryRows = [
    [
      { text: 'Almacenamiento', style: 'headerTableStatistical' },
      { text: revenueSummary.summary.storage.totalTransactions, alignment: 'center' },
      { text: `$${Number(revenueSummary.summary.storage.totalRevenue).toLocaleString('es-CO')}`, alignment: 'center' }
    ],
    [
      { text: 'Transbordo', style: 'headerTableStatistical' },
      { text: revenueSummary.summary.transshipment.totalTransactions, alignment: 'center' },
      { text: `$${Number(revenueSummary.summary.transshipment.totalRevenue).toLocaleString('es-CO')}`, alignment: 'center' }
    ],
    [
      { text: 'Total', style: 'headerTableStatistical' },
      { text: revenueSummary.summary.totals.totalTransactions, alignment: 'center' },
      { text: `$${Number(revenueSummary.summary.totals.totalRevenue).toLocaleString('es-CO')}`, alignment: 'center' }
    ]
  ];

  return {
    footer: function (currentPage, pageCount) {
      return {
        columns: [
          { text: 'DIRECCIÓN: VIA ALTERNA KM-7 CALLE 15A # 47 BIS - 11 - BUENAVENTURA', style: 'footer' },
          { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, alignment: 'right', style: 'footer' }
        ], margin: [20, 3, 20, 0]
      }
    },
    pageSize: 'legal',
    pageMargins: [20, 20, 20, 25],
    pageOrientation: 'landscape',
    content: [
      {
        image: BIG_LOGO,
        alignment: 'center'
      },
      {
        text: '"PIKI7 SAS"', fontSize: 12, bold: true, alignment: 'center'
      },
      {
        text: 'NIT. 900.368.831-9', fontSize: 10, alignment: 'center'
      },
      {
        text: revenueSummary.period?.description || 'Reporte de ingresos',
        alignment: 'center',
        fontSize: 14,
        bold: true,
        margin: [0, 18, 0, 18]
      },

      // Resumen por tipo de contenedor
      {
        text: 'Resumen por tipo de contenedor',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', 'auto', 'auto', 'auto'],
          body: byContainerTypeRows
        },
        margin: [0, 0, 0, 20]
      },

      // Detalle de almacenamiento
      {
        text: 'Detalle de almacenamiento',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
          headerRows: 1,
          body: [storageHeaders, ...storageRows]
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 20]
      },

      // Detalle de transbordo
      {
        text: 'Detalle de transbordo',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto', 'auto'],
          headerRows: 1,
          body: [transshipmentHeaders, ...transshipmentRows]
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 30]
      },
      // Resumen general
      {
        text: 'Resumen general',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', 'auto'],
          body: summaryRows
        },
        margin: [0, 0, 0, 20]
      }
    ],
    styles: {
      headerTableData: {
        bold: true,
        fillColor: '#95A5A6'
      },
      headerTableStatistical: {
        alignment: 'center',
        bold: true,
        fillColor: '#95A5A6',
        margin: [10, 0]
      },
      footer: {
        opacity: 0.4,
        fontSize: 11,
      },
      tableFilter: {
        bold: true,
      },
      tableContent: {
        fontSize: 10
      }
    }
  }
}
